export const navbar = {
	choosePackage: {
		label: {
			sv: "Välj produkter",
		},
	},
	credit: {
		label: {
			sv: "Justera kredit",
		},
	},
	contact: {
		label: {
			sv: "Kontaktuppgifter",
		},
	},
	users: {
		label: {
			sv: "Användare",
		},
	},
	sign: {
		label: {
			sv: "Granska och signera",
		},
	},
	settings: {
		label: {
			sv: "Kortuppgifter",
		},
	},
	kyc: {
		label: {
			sv: "Svara på frågor",
		},
	},
	summary: {
		label: {
			sv: "Sammanfattning",
		},
	},
	navItem: {
		stepPresentation: {
			sv: "Steg {0} av {1}",
		},
	},
};
